import SponsorProductDrawer from "./sponsored-product-drawer.js";

let customerName = "";

function getDeviceType(){
    const userAgent = navigator.userAgent;
    const width = window.innerWidth;

    if (/iPad/i.test(userAgent)) {
        return 'tablet';
    }
    if (/iPhone|iPod/i.test(userAgent)) {
        return 'mobile';
    }
    if (/Android/i.test(userAgent)) {
        if (/Mobile/i.test(userAgent)) {
            return 'mobile';
        } else {
            return 'tablet';
        }
    }

    if (width <= 576) {
        return 'mobile';
    } else if (width <= 992) {
        return 'tablet';
    }

    return 'desktop';
}

document.addEventListener("DOMContentLoaded", function () {
    const accountIcon = document.getElementById("account-icon-bubble");
    customerName = accountIcon?.getAttribute("data-customer-name") || "";

    InterfaceX.setSnippetConfig({
        userName: customerName,
        queriesPreview: [
            {
                query: window.empathySettings.initialEmptyQuery.query1,
                title: window.empathySettings.initialEmptyQuery.title1,
            },
            {
                query: window.empathySettings.initialEmptyQuery.query2,
                title: window.empathySettings.initialEmptyQuery.title2,
            },
            {
                query: window.empathySettings.initialEmptyQuery.query3,
                title: window.empathySettings.initialEmptyQuery.title3,
            }
        ]
    });
});

function renderSections(sections) {
    for (let sectionId in sections) {
        let section = document.querySelector("#" + sectionId);
        let sectionHtml = sections[sectionId];

        if (section && sectionHtml) {
            if (sectionId === 'cart-drawer') {
                let tempDiv = document.createElement('div');
                tempDiv.innerHTML = sectionHtml;

                ['CartDrawer-Header', 'CartDrawer-Contents', 'CartDrawer-Footer'].forEach(id => {
                    let newContent = tempDiv.querySelector(`#${id}`);
                    if (newContent) {
                        document.querySelector(`#${id}`).innerHTML = newContent.innerHTML;
                    }
                });
            } else {
                section.innerHTML = sectionHtml;
            }
        }
    }
}

function addToCart(id, amount) {
    let formData = {
        'items': [
            { 
                'id': id.toString(), 
                'quantity': amount,
                properties: {
                    _added_at: new Date().toISOString(),
                },
            }
        ],
        sections: 'cart-items,cart-icon-bubble,cart-live-region-text,cart-footer,cart-drawer'
    };

    const route = window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : window.Shopify.routes.cart_url + '/add.js';

    return fetch(route, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
        .then(response => response.json())
        .then(data => {
            renderSections(data.sections);
            manageProductAddToCart(data.items[0].handle, 1, '');
            document.getElementById('cart-drawer').classList.remove('is-empty');
        })
        .catch(error => console.error('Error:', error));
}

const cart = {};
fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
        data.items.forEach(item => {
            cart[item.sku] = item.quantity;
        });
        updateCartFromCounter();
    })
    .catch(error => console.error('Error obteniendo el carrito:', error));

function updateCartFromCounter() {
    const cartCounter = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (cartCounter) {
        const itemCount = parseInt(cartCounter.textContent.trim(), 10) || 0;
        InterfaceX.setSnippetConfig({ cart: { ['x']: itemCount } });
    } else {
        InterfaceX.setSnippetConfig({ cart: { ['x']: 0 } });
    }
}

// Observador para detectar cambios en el contador del carrito
const observer = new MutationObserver((mutationsList) => {
    updateCartFromCounter();
});

const cartCounterElement = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');

if (cartCounterElement) {
    observer.observe(cartCounterElement, { childList: true, subtree: true });
} else {
    console.warn("No se encontró el elemento del contador del carrito.");
}

setInterval(() => {
    updateCartFromCounter();
}, 3000);

async function getProductById(handle) {
	return await fetch(`/products/${handle}.js`).then(response => response.json());
}

let store = 'eu';
if (Shopify.locale !== 'en') {
    store = `mk${Shopify.country.toLowerCase()}`;
}

window.initX = {
    instance: 'farmaciasdirect',
    scope: getDeviceType(),
    documentDirection: "ltr",
    lang: Shopify.locale,
    store: store,
    uiLang: Shopify.locale,
    currency: 'EUR',
    consent: true,
    cart: cart,
    userName: customerName,
    callbacks: {
        UserClickedResultAddToCart: async function (result, metadata) {
            if (result.variantId !== undefined) {
                addToCart(result.variantId, 1).then(() => {
                    setTimeout(updateCartFromCounter, 500);
                });
            } else {
               const product = await getProductById(result.contents[0].data.ctproduct_handle);
               addToCart(product.variants[0].id, 1).then(() => {
                    setTimeout(updateCartFromCounter, 500);
                });
            }

            cart[result.id] = metadata.inputValue || (cart[result.id] ? cart[result.id] + result.sellPackUnit : result.sellPackUnit);

            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve({ id: result.id, addToCartEnabled: true });
                }, 1000);
            });
        },
        UserClickedResultRemoveFromCart: function (result, metadata) {
            if (metadata.inputValue === 0) {
                delete cart[result.id];
            } else {
                cart[result.id] =
                    metadata.inputValue || (cart[result.id] ? cart[result.id] - result.sellPackUnit : 0);
            }
            InterfaceX.setSnippetConfig({
                cart: {
                    ...cart,
                },
            });
        },
        UserClickedCloseX: function () {
            const searchForm = document.querySelector('search-form.header__search');
            if (searchForm) {
                searchForm.style.display = "inline-flex";
            }
        },
        UserClickedCartIcon: function () {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
                cartDrawer.open();
            } else {
                //console.error("CartDrawer element not found.");
            }
        },
        UserClickedLoginIcon: function () {
            const customerDrawer = document.querySelector('customer-drawer');
            if (customerDrawer) {
                customerDrawer.open();
            } else {
                document.getElementById('modal-access').setAttribute('open', 'true');
            }
        },
        UserClickedSponsoredMessage: function (params) {
            if (Object.keys(params).length > 0) {
                const isMobile = window.innerWidth < 768;
                const position = isMobile ? 'bottom' : 'right';
                const size = isMobile ? 'xs' : 'sm';

                const drawer = new SponsorProductDrawer(position, size);
                drawer.open(params.advertiserName, params.paidForBy, { position, size });
            }
        }
    }
};
